export default __webpack_public_path__ + "static/media/slide1.6aba4303.jpg";